import { toast } from 'react-toastify'
import { stringToUUID } from './hashing'
import styles from './toastManager.module.scss'

// A simple wrapper around the toast library to make it easier to adapt in the future.
export class ToastManager {
  static error(message, options) {
    if (!message) return

    const toastId = stringToUUID(message)
    if (toast.isActive(toastId)) {
      return
    }

    const toastOptions = {
      ...(options || {}),
      toastId: toastId,
    }
    toast.error(message, toastOptions)
  }

  static success(message, options) {
    if (!message) return

    const toastId = stringToUUID(message)
    if (toast.isActive(toastId)) {
      return
    }

    const toastOptions = {
      ...(options || {}),
      toastId: toastId,
    }
    toast.success(message, toastOptions)
  }

  static info(message, options) {
    if (!message) return

    const toastId = stringToUUID(message)
    if (toast.isActive(toastId)) {
      return
    }

    const toastOptions = {
      ...(options || {}),
      toastId: toastId,
    }
    toast.info(message, toastOptions)
  }

  static successToastWithButton(message, buttonText, buttonOnClick, options) {
    if (!message) return

    const toastId = stringToUUID(message)
    if (toast.isActive(toastId)) {
      return
    }

    const toastOptions = {
      ...(options || {}),
      toastId: toastId,
      closeOnClick: true,
      draggable: false,
    }

    toast.success(getToastWithButton(message, buttonText, buttonOnClick, toastId), toastOptions)
  }

  static infoToastWithButton(message, buttonText, buttonOnClick, options) {
    if (!message) return

    const toastId = stringToUUID(message)
    if (toast.isActive(toastId)) {
      return
    }

    const toastOptions = {
      ...(options || {}),
      toastId: toastId,
      closeOnClick: true,
      draggable: false,
    }

    toast.info(getToastWithButton(message, buttonText, buttonOnClick, toastId), toastOptions)
  }

  static errorToastWithButton(message, buttonText, buttonOnClick, options) {
    if (!message) return

    const toastId = stringToUUID(message)
    if (toast.isActive(toastId)) {
      return
    }

    const toastOptions = {
      ...(options || {}),
      toastId: toastId,
      closeOnClick: true,
      draggable: false,
    }

    toast.error(getToastWithButton(message, buttonText, buttonOnClick, toastId), toastOptions)
  }
}

// Not in class since we don't want this accessible outside this file
function getToastWithButton(message, buttonText = 'OK', buttonOnClick, toastId) {
  const ToastContent = () => (
    <div className={styles.toastParent} style={{ display: 'flex' }}>
      <div className={styles.toastText}>{message}</div>
      <button
        className={styles.toastButton}
        onClick={() => {
          toast.dismiss(toastId)
          if (buttonOnClick && typeof buttonOnClick === 'function') {
            buttonOnClick()
          }
        }}
      >
        {buttonText}
      </button>
    </div>
  )

  return <ToastContent />
}
